<template>
  <v-dialog persistent :value="editModal" width="500">
      <v-card>
        <popup-heading 
        title="UPDATE DETAILS" 
        subtitle="Update App Details" >
          <template slot="action">
            <v-btn
              depressed
              @click="closeModal()"
              fab 
              color="white"
              :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
            >
              <v-icon dark class="primary--text">close</v-icon>
            </v-btn>
            <v-btn
              depressed
              @click="updateAppDetails()"
              fab 
              color="white"
              :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
            >
              <v-icon dark class="primary--text">check</v-icon>
            </v-btn>
       
          </template>
        </popup-heading>

        <v-card-text class="pa-5">
          <!-- Create app-->
          <v-form ref="updateAppDetailForm"  lazy-validation>
           
            <v-flex xs12>
              <v-text-field
                v-model="appDetail.version"
                :rules="fieldRequired"
                label="Version"
              ></v-text-field>
            </v-flex>
             <v-flex xs12>
              <v-text-field
                v-model="appDetail.web_link"
                label="Web link"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
            <v-text-field
                v-model="appDetail.android_link"
                label="Android link"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="appDetail.ios_link"
                label="IOS link"
              ></v-text-field>
            </v-flex>
             <v-flex xs12>
              <v-text-field
                v-model="appDetail.api_url"
                :rules="urlValidation"
                label="Api url"
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-layout class="mb-3">
                <v-flex sm6 md6>
                   <p class="text-left mb-0">App Credentials </p>
                </v-flex>
                <v-flex sm6 md6 class="text-right">
                  <v-btn
                    @click="addNewObj()"
                    fab    
                    dark 
                    small
                    color="primary"
                  >
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            
               <v-card class="elevation-2 pa-2 mb-3" v-if="appDetail.api_credentials.length > 0">
                  <table class="resource-table" width="100%">
                    <tr v-bind:key="'crediential-' + index " v-for="(item, index) in appDetail.api_credentials">
                      <td>
                        <v-text-field
                          v-model="item.key"
                          :rules="fieldRequired"
                          placeholder="Your Key"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          v-model="item.value"
                          :rules="fieldRequired"
                          placeholder="Your Value"
                        ></v-text-field>
                      </td>
                      <td width="50px;" class="text-right">
                     
                          <v-btn
                            @click="removeObj(index)"
                            fab 
                            small
                            dark 
                            color="primary"
                            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2 xs-small' : 'ml-3 xs-small'"
                          >
                            <v-icon dark>fas fa-minus</v-icon>
                          </v-btn>
                         
                      </td>
                    </tr>
                  </table>
                </v-card>
             </v-flex>
    
            <v-flex xs12>
              <v-select
                v-model="appDetail.env"
                :items="envs"
                :rules="fieldRequired"
                label="Env"
              ></v-select>
            </v-flex>
          </v-form>
        
        </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  data() {
    return {
      urlValidation: [
        v => !!v || 'Field is required',
        v =>
          /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(v) || 'Invalid url',
      ],
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      appDetail: {
        version: '',
        web_link: '',
        android_link: '',
        ios_link: '',
        api_url: '',
        api_credentials: {},
        env: '',
      },
      envs: [
        'dev',
        'beta',
        'uat',
        'prod', 
      ],
    };
  },
  computed: {
    ...mapGetters({
      editModal: 'superadminapps/edit',
      editObj: 'superadminapps/editObj',
    }),
    
  },

  watch: {
    editObj(val) {
      if(!_.isEmpty(val)) {
     
        for(let key in this.appDetail){
          if(key === 'api_credentials'){
            let keyValObj = [];
            let obj = val.appDetail[key];
            for(let cred_key in obj){
              keyValObj.push({
                key: cred_key,
                value: obj[cred_key],
              })
            }
            this.appDetail[key] = keyValObj;
          } else {
            this.appDetail[key] = val.appDetail[key];
          }

        }
      }
    },
  
  },

  mounted() {
    if(this.editModal){
       this.closeModal();
    }
   
  },
  methods: {
    /**
     * Add new object
     */
    addNewObj() {
      this.appDetail.api_credentials.push({
        key: '',
        value: '',
      })
    },

    removeObj(index) {
      this.appDetail.api_credentials.splice(index, 1);
    },
    /**
     * Add Item
     */
    updateAppDetails() {
      let api_credentials = {};
      this.appDetail.api_credentials.map(item => {
        api_credentials[item.key] = item.value;
      })
      let newObj = {
        version: this.appDetail.version,
        web_link: this.appDetail.web_link,
        android_link: this.appDetail.android_link,
        ios_link: this.appDetail.ios_link,
        api_url: this.appDetail.api_url,
        api_credentials: api_credentials,
        env: this.appDetail.env,
      };
      if (this.$refs.updateAppDetailForm.validate()) {
        this.spinner(true);
        const url = `${Env.url}/api/v1/apps/${this.editObj.id}/details`;
        AuthApi.patchApi(url, newObj)
          .then((res) => {
            // Now fetch superadmin apps again
            this.fetchSuperadminApps();
            this.snackbar({
              text: res.data.msg,
              timeout: 4000,
              open: true,
            });
            this.spinner(false);
            this.closeModal();
          })
          .catch((err) => {
            this.spinner(false);
            this.snackbar({
              text: err.response.data.msg ? err.response.data.msg : 'Please try again later.',
              timeout: 4000,
              open: true,
            });
          });
      }
    },
    
     /**
     * Fetch all apps 
     */ 
    fetchSuperadminApps() {
      const url = `${Env.url}/api/v1/apps`;
      AuthApi.getApi(url)
        .then((res) => {
          this.setList(res.data.payload);
        })
        .catch(() => {
          console.log('Unale to fetch superadmin applications.')
        });
    },

    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      // Rest form values
      this.appDetail = Helper.setObjValueEmpty(this.appDetail);
      this.appDetail.api_credentials = {};
      this.setEdit(false);
      this.setEditObj({});
      this.$refs.updateAppDetailForm.reset();
    },

    ...mapActions({
      setEdit: 'superadminapps/setEdit',
      setEditObj: 'superadminapps/setEditObj',
      setList: 'superadminapps/setList',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>
